// components/RouteWrapper.js
import React from 'react';
import { DocumentTitle } from './Common/DocumentTitle';

const RouteWrapper = ({ title, children }) => {


    if (title) {
        return (
            <DocumentTitle title={title}>
                {children}
            </DocumentTitle>
        );
    }

    return children;
};

export default RouteWrapper;